import React, { useCallback } from "react";
import NoFooterModal from "../NoFooterModal";
import ConfirmationButtons from "./ConfirmationButtons/ConfirmationButtons";
import { ConfirmationModalContainer } from "./styles";
import { ConfirmationModalProps } from "./types";

type ConfirmationModalOwnProps = ConfirmationModalProps;

const ConfirmationModal = ({
  title,
  isOpen,
  toggle,
  accept,
  decline,
  children,
}: ConfirmationModalOwnProps) => {
  const acceptAndToggle = useCallback(() => {
    accept();
    toggle();
  }, [accept, toggle]);

  return (
    <NoFooterModal
      title={title}
      isOpen={isOpen}
      toggle={toggle}
      data-cy="confirmation-modal"
    >
      <ConfirmationModalContainer>
        {children}
        <ConfirmationButtons onAccept={acceptAndToggle} onDecline={decline} />
      </ConfirmationModalContainer>
    </NoFooterModal>
  );
};

export default ConfirmationModal;
